import { render, staticRenderFns } from "./editorial-component.vue?vue&type=template&id=f6905358"
import script from "./editorial-component.vue?vue&type=script&lang=js"
export * from "./editorial-component.vue?vue&type=script&lang=js"
import style0 from "./editorial-component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports